import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
    background-color: lightgreen;
    height: 100%; 
`;

const About = () => (
    <Div color>About page</Div>
);

export default About;


// WEBPACK FOOTER //
// ./src/components/Page/About/default.jsx